var map = {
	"./icon-court.svg": "1434",
	"./icon-discipline.svg": "6794",
	"./icon-pie.svg": "5881",
	"./icon-teacher.svg": "6e90",
	"./icon-test.svg": "eb5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aeb6";